// extracted by mini-css-extract-plugin
module.exports = {"heading":"accordion-item_heading__THQfR","button":"accordion-item_button__t1ptC","arrow":"accordion-item_arrow__4caWl","panel":"accordion-item_panel__13hQm"};